import { CanActivateFn } from '@angular/router';
import { Injectable, inject } from '@angular/core';

import { AuthService } from '../../auth.service';

Injectable({
  providedIn: 'root'
})
export const loginGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService)

  if(!authService.isAuthenticated()) {
    return false
  }

  return true
};